// src/admin/pages/MeditationList.js
import React from 'react';
import { useGetAllMeditationConfigsQuery, selectMeditationConfigIds } from '../../features/meditation/meditationApi';
import Meditation from '../meditation/Meditation';
import { Link } from 'react-router-dom';
// Remove PulseLoader as we are using react-bootstrap Spinner
// import PulseLoader from 'react-spinners/PulseLoader';
import { useSelector } from 'react-redux';
// Import react-bootstrap components
import { Spinner, Alert, Button } from 'react-bootstrap';


const MeditationList = () => {
  const {
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetAllMeditationConfigsQuery('meditationList', {
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const configIds = useSelector(state => selectMeditationConfigIds(state, 'meditationList'));

  console.log('Meditation Config IDs from selector (after create):', configIds);

  let content;

  if (isLoading) {
    // Loading Spinner UI consistent with ContentList
    content = (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (isError) {
    // Error Alert UI consistent with ContentList
    content = (
      <Alert variant="danger" className="mt-4 text-center">
        {error?.data?.message || "Error loading meditation config."}
      </Alert>
    );
  }

  if (isSuccess) {
    const tableContent = configIds.map((configId, index) =>
      <Meditation key={configId} configId={configId} index={index} />
    );

    content = (
      <>
        {/* 'Add New Meditation Config' button, similar to ContentList's 'Add New Content' */}
        <Link to="/dashboard/meditation/new" className="button button--primary new-config-button">
          <Button variant="primary">Add New Meditation Config</Button>
        </Link>

        {/* Table structure consistent with ContentList */}
        <div className="table-responsive"> {/* For responsive table behavior */}
            <table className="table table--meditation"> {/* Using 'table--meditation' class */}
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th">#</th>
                        <th scope="col" className="table__th">Name</th>
                        <th scope="col" className="table__th">Category</th>
                        <th scope="col" className="table__th">Days</th>
                        <th scope="col" className="table__th">Time</th>
                        <th scope="col" className="table__th">Type</th>
                        <th scope="col" className="table__th">Active</th>
                        <th scope="col" className="table__th">Actions</th>
                    </tr>
                </thead>
                <tbody className="table__tbody">
                    {tableContent}
                </tbody>
            </table>
        </div>

        {/* 'No contents found' message, with similar logic as ContentList */}
        {/* This now includes isLoading and isError checks even if configIds.length === 0 */}
        {!isLoading && !isError && configIds.length === 0 && (
            <p className="text-center mt-4">No meditation config found.</p>
        )}

        {/* Pagination is not included as per the request "no base filters",
            and the current Meditation API query does not support pagination parameters. */}
      </>
    );
  }

  return content;
};

export default MeditationList;